<div [matTooltip]="libelle" class="container"  [attr.aria-label]="libelle">
    <div class="row">
        <div *ngFor="let color of colors" class="col block" [class]="color">&nbsp;</div>
    </div>
</div>